import type { DeliverableTile } from "../../../api/types";
import { Card, EmptyState, SheetIcon } from "../../../ui";
import { tileNote } from "../model/words";

interface DeliverableTilesProps {
  tiles: readonly DeliverableTile[];
  /** A tile was pressed: the goal box is filled with a sentence about it. */
  onPick(tile: DeliverableTile): void;
}

/** The sentence that goes into the goal box when a tile is pressed. */
export function goalForTile(tile: DeliverableTile): string {
  return `Work out what the ${tile.name} needs`;
}

/** Tiles to start from each kind of document the framework should produce, each with its kind letter A, B or C. */
export function DeliverableTiles({ tiles, onPick }: DeliverableTilesProps) {
  return (
    <Card aria-labelledby="tiles-title" className="nv-tiles">
      <h2 id="tiles-title">Start from a document</h2>
      {tiles.length === 0 ? (
        <EmptyState title="No documents to start from yet">The target documents come with the starter pack. When your team loads them, they appear here.</EmptyState>
      ) : (
        <ul className="nv-tiles__list">
          {tiles.map((tile) => (
            <li key={tile.document_kind_id}>
              <button type="button" className="nv-tile" onClick={() => onPick(tile)} aria-label={`Start from ${tile.name}`}>
                <SheetIcon kind={tile.deliverable_kind} label={tile.name} size={26} />
                <span className="nv-tile__name">{tile.name}</span>
                <span className="nv-tile__note muted">{tileNote(tile)}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
